<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Orders Invoice</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12 pt-0">
          <v-layout
            wrap
            style="margin: 0px"
          >
            <v-flex
              xs12
              sm8
              md5
            >
              <v-select
                style="width: 100%"
                autocomplete
                :items="customersList"
                v-model="tableData.customer"
                label="Customer"
                single-line
                clearable
                @input="filterByCustomer()"
              />
            </v-flex>

            <v-flex
              xs12
              sm4
              md5
              style="padding-top: 15px"
            >
              <v-btn
                :disabled="transactionsArray.length < 1"
                style="height: auto; padding: 4px; margin-left: 15px"
                @click="printInvoices"
                depressed
                color="primary"
                small
              >
                Print all
              </v-btn>
            </v-flex>
          </v-layout>

          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.credit_log_transaction_id"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    :disabled="!tableData.customer"
                    type="checkbox"
                    :value="r.credit_log_transaction_id"
                    v-model="transactionsArray"
                  />
                </td>
                <td v-if="r.is_open === '0'">
                  <div class="media-left">
                    {{ r.theOrderID }}
                    <span
                      class="status-mark bg-danger-600 media-badge"
                      style="margin-top: 2px; left: -10px"
                    ></span>
                  </div>
                </td>
                <td v-else>{{ r.theOrderID }}</td>
                <td>
                  <span v-if="r.order_status === 'new_order'">
                    <span class="label bg-primary-600"> {{ r.order_status.replace('_', ' ') }}</span>
                  </span>
                  <span v-if="r.order_status === 'processed_order'">
                    <span class="label bg-indigo-600"> {{ r.order_status.replace('_', ' ') }}</span>
                  </span>
                  <span v-if="r.order_status === 'canceled'">
                    <span class="label bg-orange-600"> {{ r.order_status }}</span>
                  </span>
                  <span v-if="r.order_status === 'refunded'">
                    <span class="label bg-danger-600"> {{ r.order_status }}</span>
                  </span>
                  <span v-if="r.order_status === 'approved_order'">
                    <span class="label bg-green-600"> {{ r.order_status.replace('_', ' ') }}</span>
                  </span>
                  <span v-if="r.order_status === 'purchased'">
                    <span class="label bg-teal-400"> {{ r.order_status }}</span>
                  </span>
                  <span v-if="r.order_status === 'warehouse_delivered_order'">
                    <span class="label bg-purple-400">
                      {{ r.order_status.replace('_', ' ').replace('_order', '') }}</span>
                  </span>
                  <span v-if="r.order_status === 'int_shipment'">
                    <span class="label bg-info-400"> {{ r.order_status.replace('_', ' ') }}</span>
                  </span>
                  <span v-if="r.order_status === 'branch_delivery'">
                    <span class="label bg-violet-600"> {{ r.order_status.replace('_', ' ') }}</span>
                  </span>
                  <span v-if="r.order_status === 'delivered'">
                    <span class="label bg-warning-300"> {{ r.order_status.replace('_', ' ') }}</span>
                  </span>
                  <span v-if="r.order_status === 'archived'">
                    <span v-if="r.is_canceled == '1'">
                      <span class="label bg-orange-600">canceled</span>
                    </span>
                    <span
                      v-else
                      class="label bg-warning-300"
                    >
                      {{ r.order_status }}</span>
                  </span>
                </td>
                <td>{{ r.invoice_number }}</td>
                <td>{{ r.user_id }}</td>
                <!-- <td>{{ r.branch_name }}</td> -->
                <td class="ws-nowrap">
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>{{ r.phone_number }}</td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                </td>
                <td>{{ r.product_name }}</td>
                <td>
                  <span :class="
                      r.country == 'USA' ? 'flag-icon flag-icon-us' : 'flag-icon flag-icon-tr'
                    "></span>
                  &nbsp; {{ r.country }}
                </td>
                <td v-if="r.credit_log_transaction_date != null">
                  {{ r.credit_log_transaction_date }}
                </td>
                <td v-else>{{ r.created_at }}</td>
                <td style="padding-left:10px; padding-right:10px">
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showAppLog', r.credit_log_transaction_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isTransactionOrder="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  <span v-if="r.is_open === '0'">
                    <div class="media-left">
                      {{ r.theOrderID }}
                      <span
                        class="status-mark bg-danger-600 media-badge"
                        style="margin-top: 2px; left: -10px"
                      ></span>
                    </div>
                  </span>
                  <span v-else>{{ r.theOrderID }}</span>
                  , <br />
                  Invoice No: {{ r.invoice_number }} , <br />
                  {{ r.product_name }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                  <br />
                  <span :class="
                      r.country == 'USA' ? 'flag-icon flag-icon-us' : 'flag-icon flag-icon-tr'
                    "></span>
                  &nbsp; {{ r.country }} ,
                </td>

                <td>
                  CustomerID: {{ r.user_id }} , <br />
                  Name: {{ r.full_name }} , <br />
                  Phone: {{ r.phone_number }} , <br />
                  <span v-if="r.credit_log_transaction_date != null">
                    {{ r.credit_log_transaction_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  , <br />
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showAppLog', r.credit_log_transaction_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-log-details
            :detialData="detialData"
            :closeModal="closeModal"
            :companyData="companyData"
          ></view-log-details>

          <multiple-invoices
            :invoicesData="invoicesData"
            :closeModal="closeModal"
            :invoicesModal="invoicesModal"
            :companyData="companyData"
            @close="invoicesModal = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import viewLogDetails from './viewLogDetails.vue'
import mobileDatatable from '../mobileDatatable'
import multipleInvoices from './multipleInvoices.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-log-details': viewLogDetails,
    'mobile-datatable': mobileDatatable,
    multipleInvoices
  },
  created() {
    this.getResults()
  },
  mounted() {
    this.getCustomer()
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check Box', value: '1' },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'theOrderID'
      },
      {
        label: 'Order Status',
        text: 'Order Status',
        value: '3',
        sortable: true,
        searchable: false,
        name: 'order_status'
      },
      {
        label: 'Invoice No',
        text: 'Invoice No',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'invoice_number'
      },
      // {
      //   label: 'Branch',
      //   text: 'Branch',
      //   value: '5',
      //   sortable: true,
      //   searchable: false,
      //   name: 'branch_name'
      // },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'user_id'
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'customer_note'
      },
      {
        label: 'Phone Number',
        text: 'Phone Number',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'phone_number'
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'product_url'
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'product_name'
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'country'
      },
      {
        label: 'Transaction Date',
        text: 'Transaction Date',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'credit_log_transaction_date'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      transactionsArray: [],
      customersList: [],
      selectedCustomer: 0,
      url: 'api/credit_log_transactions',
      logDetailUrl: 'api/credit_log_transactions',
      companyUrl: 'api/company_info',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      creditLogTransactionID: [],
      detialData: {},
      invoicesData: {},
      invoicesModal: false,
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'credit_log_transaction_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_log_transaction_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        customer: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    printInvoices() {
      let token = localStorage.getItem('access_token')

      this.getCompanyData(token)

      axios
        .post('api/get_invoices', { ids: this.transactionsArray }, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.invoicesData = response.data.data
          this.invoicesModal = true
          this.modal('invoicesModal')
        })
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-customer-to-select', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.customersList = []
          let result = response.data.data

          result.forEach(c => {
            this.customersList.push({
              text: c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id
            })
          })
        })
    },

    filterByCustomer() {
      this.transactionsArray = []
      this.getResults()
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getCreditLogTransactionID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    getCreditLogTransactionID(creditLog) {
      this.creditLogTransactionID = []
      for (let i = 0; i < creditLog.length; i++) {
        this.creditLogTransactionID[i] = creditLog[i].credit_log_transaction_id
      }
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_log_transaction_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_log_transaction_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.sortByColumn()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_log_transaction_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_log_transaction_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    sendToExport() {
      let searchValue = this.tableData.search !== '' ? this.tableData.search : '0'
      let column = this.tableData.column !== '' ? this.tableData.column : '0'
      let sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0'
      let searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0'
      let searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0'
      let fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0'
      let toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0'
      let loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
      let warehouses = loggedInUserData.warehouse_id_fk
      let perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page
      if (
        searchValue !== '0' ||
        searchedOneCol !== '0' ||
        searchedOneVal !== '0' ||
        toDate !== '0' ||
        fromDate !== '0'
      ) {
        perPage = '0'
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName

      window.location.replace(
        fullHostName +
        '/api/order-transaction-export?searchValue=' +
        searchValue +
        '&column=' +
        column +
        '&sortDir=' +
        sortDir +
        '&searchedOneCol=' +
        searchedOneCol +
        '&searchedOneVal=' +
        searchedOneVal +
        '&from_date=' +
        fromDate +
        '&to_date=' +
        toDate +
        '&warehouses=' +
        warehouses +
        '&per_page=' +
        perPage
      )
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      this.getResults()
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)
      axios
        .get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data

          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.companyData = response.data.data
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.transactionsArray = []
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/logs/creditLogTransaction.vue